module.exports = __webpack_public_path__ + "static/media/Industry-Medium.42b5eea4.eot";